
export const CalendarV1 = (props) => {
  return (
    <input
      value={props.value}
      onChange={props.onChange}
      className="calendarV1"
      type="date"
      id={props.id}
      min={props.min}
      max={props.max}
    />
  );
};
